import config from "@app/config";
import axios from "@app/services/axios";




export const login = (loginPayload: any): Promise<any> =>
    axios.post<any>('/api/users/login', { ...loginPayload }).then((res: any) => {


        return res.data;

    });


export const sendPasswordOTP = (payload: any): Promise<any> =>
    axios.post<any>('/api/users/sendResetPasswordOTP', { ...payload }).then((res: any) => {


        return res.data;

    });

export const changePasswordViaOtp = (payload: any): Promise<any> =>
    axios.post<any>('/api/users/changepassword', { ...payload }).then((res: any) => {


        return res.data;

    });



export const createCategory = (createCategoryPayload: any): Promise<any> =>
    axios.post<any>('/api/categories', { ...createCategoryPayload }).then((res: any) => {


        return res.data;

    });

export const createProduct = (createProductPayload: any): Promise<any> =>
    axios.post<any>('/api/products', { ...createProductPayload }).then((res: any) => {


        return res.data;

    });
export const updateCategory = (updateCategoryPayload: any): Promise<any> =>
    axios.put<any>('/api/categories/' + updateCategoryPayload.id, { ...updateCategoryPayload }).then((res: any) => {


        return res.data;

    });

export const updateProduct = (updateProductPayload: any): Promise<any> =>
    axios.put<any>('/api/products/' + updateProductPayload.id, { ...updateProductPayload }).then((res: any) => {


        return res.data;

    });

export const updateInternalUser = (updateUserPayload: any): Promise<any> =>
    axios.put<any>('/api/users/update-user/' + updateUserPayload._id, { ...updateUserPayload }).then((res: any) => {


        return res.data;

    });

export const updateInternalProfile = (updateUserPayload: any): Promise<any> =>
    axios.put<any>('/api/users/' + updateUserPayload.id, { ...updateUserPayload }).then((res: any) => {


        return res.data;

    });
export const updateExternalUserOtherInfo = (updateUserPayload: any): Promise<any> =>
    axios.put<any>('/api/users/externalUserOtherInfo/' + updateUserPayload.id, { ...updateUserPayload }).then((res: any) => {


        return res.data;

    });

export const getInternalUserById = (id: string): Promise<any> =>
    axios.get<any>('/api/users/' + id).then((res: any) => {


        return res.data;

    });

export const getProductById = (id: string): Promise<any> =>
    axios.get<any>('/api/products/' + id).then((res: any) => {


        return res.data;

    });


export const getAllInternalUsers = (params: any): Promise<any> =>
    axios.get<any>('/api/users/get-users?' + new URLSearchParams(params as any).toString()).then((res: any) => {


        return res.data;

    });

export const getAllCategories = (): Promise<any> =>
    axios.get<any>('/api/categories').then((res: any) => {


        return res.data;

    });

export const getAllProducts = (params: any): Promise<any> =>
    axios.get<any>('/api/products/admin?' + new URLSearchParams(params as any).toString()).then((res: any) => {


        return res.data;

    });



export const getAllClients = (clinicId: number): Promise<any> =>
    axios.get<any>('/api/users/clients/' + clinicId).then((res: any) => {


        return res.data;

    });


export const getStatesTree = (): Promise<any> =>
    axios.get<any>('/areas/states').then((res: any) => {


        return res.data;

    });
export const getGeoJSONData = (): Promise<any> =>
    axios.get<any>('/api/geoJSON/admin').then((res: any) => {


        return res.data;

    });

export const getSectorsData = (): Promise<any> =>
    axios.get<any>('/api/admin/miscellaneous/sectors').then((res: any) => {


        return res.data;

    });



export const createGeoJSONData = (payload: any): Promise<any> =>
    axios.post<any>('/api/geoJSON/admin', { ...payload }).then((res: any) => {


        return res.data;

    });

export const updateGeoJSONData = (payload: any): Promise<any> =>
    axios.put<any>('/api/geoJSON/admin', { ...payload }).then((res: any) => {


        return res.data;

    });

export const deleteGeoJsonData = (id: any): Promise<any> =>
    axios.delete<any>('/api/geoJSON/admin/' + id).then((res: any) => {


        return res.data;

    });



export const getAllVariant = (): Promise<any> =>
    axios.get<any>('/api/variants').then((res: any) => {


        return res.data;

    });

export const getSingleVariant = (id: String): Promise<any> =>
    axios.get<any>('/api/variants/' + id).then((res: any) => {


        return res.data;

    });

export const createVariant = (payload: any): Promise<any> =>
    axios.post<any>('/api/variants', { ...payload }).then((res: any) => {


        return res.data;

    });

export const updateVariant = (id: string, payload: any): Promise<any> =>
    axios.put<any>('/api/variants/' + id, { ...payload }).then((res: any) => {


        return res.data;

    });

export const deleteVariant = (id: string): Promise<any> =>
    axios.delete<any>('/api/variants/' + id).then((res: any) => {


        return res.data;

    });

export const getAllOrders = (params: any): Promise<any> =>
    axios.get<any>('/api/admin/orders?' + new URLSearchParams(params as any).toString()).then((res: any) => {


        return res.data;

    });
export const getAllSubscriptions = (params: any): Promise<any> =>
    axios.get<any>('/api/admin/orders/subscriptions?' + new URLSearchParams(params as any).toString()).then((res: any) => {


        return res.data;

    });

export const orderSearch = (orderId: any): Promise<any> =>
    axios.get<any>('/api/admin/orders/search/' + orderId).then((res: any) => {


        return res.data;

    });

export const getAllRiders = (params: any): Promise<any> =>
    axios.get<any>('/api/admin/riders?' + new URLSearchParams(params as any).toString()).then((res: any) => {


        return res.data;

    });
export const updateRiderStatus = (id: string, body: any): Promise<any> =>
    axios.patch<any>('/api/admin/riders/' + id, { ...body }).then((res: any) => {


        return res.data;

    });

export const initiateRefund = (body: any): Promise<any> =>
    axios.post<any>('/api/admin/orders/refund', { ...body }).then((res: any) => {


        return res.data;

    });

export const assignRider = (id: string, deliveryIds: any): Promise<any> =>
    axios.put<any>('/api/admin/riders/assign/' + id, { deliveryIds: deliveryIds }).then((res: any) => {


        return res.data;

    });

export const updateDeliveryStatus = (id: string, body: any): Promise<any> =>
    axios.put<any>('/api/admin/orders/deliveries', { ...body }).then((res: any) => {


        return res.data;

    });



export const updateClientAddress = (id: string, body: any): Promise<any> =>
    axios.put<any>('/api/admin/miscellaneous/clients/addresses/' + id, { ...body }).then((res: any) => {


        return res.data;

    });

export const updateClientDefaultAddress = (clientId: string, addressId: string): Promise<any> =>
    axios.patch<any>('/api/admin/miscellaneous/clients/addresses/' + clientId + '/' + addressId).then((res: any) => {


        return res.data;

    });



export const createClientAddressStatus = (body: any): Promise<any> =>
    axios.post<any>('/api/admin/miscellaneous/clients/addresses', { ...body }).then((res: any) => {


        return res.data;

    });

export const getAllClientsOfDairy = (params: any): Promise<any> =>
    axios.get<any>('/api/admin/miscellaneous/clients?' + new URLSearchParams(params as any).toString()).then((res: any) => {


        return res.data;

    });
export const getAddressesOfClient = (id: string): Promise<any> =>
    axios.get<any>('/api/admin/miscellaneous/clients/addresses/' + id).then((res: any) => {


        return res.data;

    });
export const deleteAddressOfClient = (id: string): Promise<any> =>
    axios.delete<any>('/api/admin/miscellaneous/clients/addresses/' + id).then((res: any) => {


        return res.data;

    });


export const getAllDeliveriesOfSubscription = (id: string, params: any): Promise<any> =>
    axios.get<any>('/api/admin/orders/subscriptions/' + id + '/deliverydates?' + new URLSearchParams(params as any).toString()).then((res: any) => {


        return res.data;

    });
export const getAllDeliveries = (params: string): Promise<any> =>
    axios.get<any>('/api/admin/orders/alldeliveries?' + new URLSearchParams(params as string).toString()).then((res: any) => {


        return res.data;

    });

export const getAllInvoices = (params: string): Promise<any> =>
    axios.get<any>('/api/admin/orders/invoices?' + new URLSearchParams(params as string).toString()).then((res: any) => {


        return res.data;

    });


export const getAllTransactions = (params: string): Promise<any> =>
    axios.get<any>('/api/admin/miscellaneous/transactions?' + new URLSearchParams(params as string).toString()).then((res: any) => {


        return res.data;

    });


export const getCategoryById = (id: string): Promise<any> =>
    axios.get<any>('/api/categories/' + id).then((res: any) => {


        return res.data;

    });

export const getOrderById = (id: number): Promise<any> =>
    axios.get<any>('/api/orders/' + id).then((res: any) => {


        return res.data;

    });


export const saveFacility = (createUserPayload: any): Promise<any> =>
    axios.post<any>('/miscellaneous/facility', { ...createUserPayload }).then((res: any) => {


        return res.data;

    });


export const saveRecharges = (createRechargePayload: any): Promise<any> =>
    axios.post<any>('/api/admin/miscellaneous/recharges', { ...createRechargePayload }).then((res: any) => {


        return res.data;

    });
export const getRecharges = (createRechargePayload: any): Promise<any> =>
    axios.get<any>('/api/admin/miscellaneous/recharges', { ...createRechargePayload }).then((res: any) => {


        return res.data;

    });

export const createInternalUser = (createUserPayload: any): Promise<any> =>
    axios.post<any>('/api/users/create-user', { ...createUserPayload }).then((res: any) => {


        return res.data;

    });

export const updateFacility = (updateUserPayload: any): Promise<any> =>
    axios.put<any>('/miscellaneous/facility/' + updateUserPayload.id, { ...updateUserPayload }).then((res: any) => {


        return res.data;

    });









/** medicines */








export const getOtherInfoById = (id: number): Promise<any> =>
    axios.get<any>('/miscellaneous/otherinfo/' + id).then((res: any) => {


        return res.data;

    });



export const saveOtherInfo = (createUserPayload: any): Promise<any> =>
    axios.post<any>('/miscellaneous/otherinfo', { ...createUserPayload }).then((res: any) => {


        return res.data;

    });



export const updateOtherInfo = (updateUserPayload: any): Promise<any> =>
    axios.put<any>('/miscellaneous/otherinfo/' + updateUserPayload.id, { ...updateUserPayload }).then((res: any) => {


        return res.data;

    });





/** testimonials */

export const getAllTestimonials = (): Promise<any> =>
    axios.get<any>('/miscellaneous/testimonial').then((res: any) => {


        return res.data;

    });

export const getTestimonialsById = (id: number): Promise<any> =>
    axios.get<any>('/miscellaneous/testimonial/' + id).then((res: any) => {


        return res.data;

    });



export const saveTestimonials = (createUserPayload: any): Promise<any> =>
    axios.post<any>('/miscellaneous/testimonial', { ...createUserPayload }).then((res: any) => {


        return res.data;

    });



export const updateTestimonials = (updateUserPayload: any): Promise<any> =>
    axios.put<any>('/miscellaneous/testimonial/' + updateUserPayload.id, { ...updateUserPayload }).then((res: any) => {


        return res.data;

    });



export const SendInvitationEmails = (payload: any): Promise<any> =>
    axios.post<any>('/miscellaneous/sendBulkInvitations', { ...payload }).then((res: any) => {


        return res.data;

    });




export const getAdminDashboardInfo = (): Promise<any> =>
    axios.get<any>('/miscellaneous/adminDashboardInfo').then((res: any) => {


        return res.data;

    });

export const getClinicDashboardInfo = (id: number): Promise<any> =>
    axios.get<any>('/miscellaneous/clinicDashboardInfo/' + id).then((res: any) => {


        return res.data;

    });

// Push Notifications API functions
export const createPushNotification = (createPushNotificationPayload: any): Promise<any> =>
    axios.post<any>('/api/admin/push-notifications', { ...createPushNotificationPayload }).then((res: any) => {
        return res.data;
    });

export const updatePushNotification = (updatePushNotificationPayload: any): Promise<any> =>
    axios.put<any>('/api/admin/push-notifications/' + updatePushNotificationPayload.id, { ...updatePushNotificationPayload }).then((res: any) => {
        return res.data;
    });

export const getAllPushNotifications = (params?: any): Promise<any> => {
    const queryString = params ? '?' + new URLSearchParams(params as any).toString() : '';
    return axios.get<any>('/api/admin/push-notifications' + queryString).then((res: any) => {
        return res.data;
    });
};

export const getPushNotificationById = (id: string): Promise<any> =>
    axios.get<any>('/api/admin/push-notifications/' + id).then((res: any) => {
        return res.data;
    });

export const deletePushNotification = (id: string): Promise<any> =>
    axios.delete<any>('/api/admin/push-notifications/' + id).then((res: any) => {
        return res.data;
    });

export const sendPushNotification = (sendPushNotificationPayload: any): Promise<any> =>
    axios.post<any>('/api/admin/push-notifications/send', { ...sendPushNotificationPayload }).then((res: any) => {
        return res.data;
    });

export const updateClientBalance = (clientId: string, balance: number): Promise<any> =>
    axios.put<any>('/api/admin/miscellaneous/clients/balance/' + clientId, { balance }).then((res: any) => {
        return res.data;
    });

export const getAllPaymentLogs = (params: any): Promise<any> =>
    axios.get<any>('/api/admin/miscellaneous/payment-logs?' + new URLSearchParams(params as any).toString()).then((res: any) => {
        return res.data;
    });

// ─── Delivery Slot API ────────────────────────────────────────────────────────

export const getAllDeliverySlots = (): Promise<any> =>
    axios.get<any>('/api/admin/miscellaneous/delivery-slots').then((res: any) => res.data);

export const createDeliverySlot = (payload: any): Promise<any> =>
    axios.post<any>('/api/admin/miscellaneous/delivery-slots', { ...payload }).then((res: any) => res.data);

export const updateDeliverySlot = (id: string, payload: any): Promise<any> =>
    axios.put<any>('/api/admin/miscellaneous/delivery-slots/' + id, { ...payload }).then((res: any) => res.data);

export const deleteDeliverySlot = (id: string): Promise<any> =>
    axios.delete<any>('/api/admin/miscellaneous/delivery-slots/' + id).then((res: any) => res.data);

export const toggleDeliverySlot = (id: string): Promise<any> =>
    axios.patch<any>('/api/admin/miscellaneous/delivery-slots/' + id + '/toggle').then((res: any) => res.data);

// App Settings
export const getAppSettings = (): Promise<any> =>
    axios.get<any>('/api/admin/miscellaneous/app-settings').then((res: any) => res.data);

export const updateAppSettings = (data: any): Promise<any> =>
    axios.put<any>('/api/admin/miscellaneous/app-settings', data).then((res: any) => res.data);

// ─── First Recharge Coupons API ───────────────────────────────────────────────
export const getFirstRechargeConfig = (): Promise<any> =>
    axios.get<any>('/api/admin/coupons/config').then((res: any) => res.data);

export const updateFirstRechargeConfig = (payload: any): Promise<any> =>
    axios.put<any>('/api/admin/coupons/config', { ...payload }).then((res: any) => res.data);

export const getCoupons = (params?: any): Promise<any> => {
    const queryString = params ? '?' + new URLSearchParams(params as any).toString() : '';
    return axios.get<any>('/api/admin/coupons' + queryString).then((res: any) => res.data);
};

export const bulkGenerateCoupons = (payload: any): Promise<any> =>
    axios.post<any>('/api/admin/coupons/bulk-generate', { ...payload }).then((res: any) => res.data);

export const deleteCoupon = (id: string): Promise<any> =>
    axios.delete<any>('/api/admin/coupons/' + id).then((res: any) => res.data);

// ─── Meta Ads API ─────────────────────────────────────────────────────────────
export const getMetaAdsConfig = (): Promise<any> =>
    axios.get<any>('/api/admin/meta-ads/config').then((res: any) => res.data);

export const updateMetaAdsConfig = (payload: any): Promise<any> =>
    axios.put<any>('/api/admin/meta-ads/config', { ...payload }).then((res: any) => res.data);

export const sendMetaAdsTestEvent = (payload: any): Promise<any> =>
    axios.post<any>('/api/admin/meta-ads/test-event', { ...payload }).then((res: any) => res.data);

// ─── Sliders / Banners API ────────────────────────────────────────────────────
export const getAllSliders = (params?: any): Promise<any> => {
    const queryString = params ? '?' + new URLSearchParams(params as any).toString() : '';
    return axios.get<any>('/api/admin/sliders' + queryString).then((res: any) => res.data);
};

export const createSlider = (payload: any): Promise<any> =>
    axios.post<any>('/api/admin/sliders', { ...payload }).then((res: any) => res.data);

export const updateSlider = (id: string, payload: any): Promise<any> =>
    axios.put<any>('/api/admin/sliders/' + id, { ...payload }).then((res: any) => res.data);

export const deleteSlider = (id: string): Promise<any> =>
    axios.delete<any>('/api/admin/sliders/' + id).then((res: any) => res.data);

export const toggleSliderStatus = (id: string): Promise<any> =>
    axios.patch<any>('/api/admin/sliders/' + id + '/toggle-status').then((res: any) => res.data);



